import PageHeader from "../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import PathChanger from "../../../components/PagesComponents/Setting/Profile/PathChanger.component";
import { ReactComponent as AdminInfoIcon } from "../../../assets/Icons/Setting/Profile/AdminInfoIcon.svg";
import LogoutIcon from "../../../assets/Icons/Setting/Profile/LogoutIcon.svg";
import { Helmet } from "react-helmet";

const Body = ({
  currentTab,
  handelCurrentTab,
  intituteIcons,
  institutePathName,
  institutePaths,
}) => {
  return (
    <div
      className="flex-col align-start justify-start g-1 overflow-hide   "
      style={{ height: "calc(90vh - 1rem)" }}
    >
      <Helmet>
        <title>Profile</title>
      </Helmet>
      <PageHeader />

      <div className="w-full overflow-hide flex-row align-start justify-start g-1 flex-1 ">
        {/* left container */}
        <div
          className=" flex-col align-start justify-between g-1 h-full"
          style={{ width: "18rem" }}
        >
          <div
            className="w-full flex-col align-start justify-start p-2 back-white radius-10"
            style={{ gap: "1.2rem", padding: "1.2rem" }}
          >
            <h4 className="t-15 poppins-medium weight-500">Personal details</h4>
            <PathChanger
              title={"Admin info"}
              icon={
                <AdminInfoIcon
                  className={
                    currentTab === "admininfo"
                      ? "activeSettingPathChangerBtnIcon"
                      : ""
                  }
                />
              }
              pathName={"admininfo"}
            />
          </div>
          {/* middle block */}
          <div
            className="w-full flex-1 flex-col align-start justify-start p-2 back-white radius-10"
            style={{ gap: "1.2rem", padding: "1.2rem" }}
          >
            <h4 className="t-15 poppins-medium weight-500">
              Institutional details
            </h4>
            <div className="w-full flex-col-align-start-justify-start g-05">
              {institutePaths.map((title) => {
                return (
                  <PathChanger
                    title={title}
                    icon={intituteIcons[title]}
                    pathName={institutePathName[title]}
                  />
                );
              })}
            </div>
          </div>
          <div className="w-full flex-col align-start justify-start p-2 back-white radius-10">
            <button
              type="button"
              className="transparentBtn flex-row align-center justify-center g-05 w-full"
            >
              <span
                style={{ color: "var(--deepPink2)" }}
                className="poppins t-14"
              >
                Logout
              </span>
              <img src={LogoutIcon} alt="" />
            </button>
          </div>
        </div>

        {/* right container */}
        <div className="flex-col align-start justify-start flex-1  scroll-y pr-1 h-full">
          {handelCurrentTab()}
        </div>
      </div>
    </div>
  );
};

export default Body;
